import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import "./index.css";
import App from "./App";
import { AuthProvider } from "./context/AuthContext";

// Suppress "Support for defaultProps will be removed" warning from NextUI v1
const originalConsoleError = console.error;
console.error = (...args) => {
  if (typeof args[0] === "string" && /Support for defaultProps will be removed/.test(args[0])) {
    return;
  }
  originalConsoleError(...args);
};

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
